import { FileSchema } from "./File";
import { UserCardSchema } from "./User";

export interface TicketListItemSchema {
  id: number;
  ticket_number: string;
  caption: string;
  department: string;
  status: TicketStatusEnum;
  updated_at: string;
  created_at: string;
  creator: {
    id: number;
    name?: null | string;
    email?: null | string;
    email_verified_at: null | string;
    mobile: string;
    mobile_verified_at: string;
    created_at: string;
    updated_at: string;
  };
}

export enum TicketStatusEnum {
  PENDING = "pending",
  ANSWERED = "answered",
  CLOSED = "closed",
  IN_PROGRESS = "in_progress",
}

export interface TicketDetailsSchema extends TicketListItemSchema {
  activities: TicketActivitySchema[];
}
export interface TicketActivitySchema {
  description: string;
  created_at: string;
  creator_role: string;
  is_private: 0 | 1;
  file: FileSchema;
  user: UserCardSchema;
}
